import React from 'react';

const Delete = ({ className = '', onClick = () => null, color = '#161616' }) => {
  return (
    <div className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='17'
        height='12'
        viewBox='0 0 17 12'
        fill='none'
      >
        <path
          d='M15 1H1M1 5H8M8 9H1M12 7L16 11M16 7L12 11'
          stroke={color}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </div>
  );
};

export default Delete;
